'use client';
import { getIconBaseUrl } from '../../../utils/assets';
import SelectBox from './SelectBox';
import React, { useState } from 'react';
import styles from './DateSelectCarousel.module.scss';
export const DateSelectCarousel = ({ dates = [], preSelectedNights, onChange, topic = 'dates', name = 'NightSelectorCarousel', }) => {
    const [carouselPosition, setCarouselPosition] = useState(preSelectedNights ? Math.floor(preSelectedNights / 4) : 0);
    const handleNext = () => {
        if (carouselPosition < dates.length / 4 - 1)
            setCarouselPosition(carouselPosition + 1);
    };
    const handlePrev = () => {
        if (carouselPosition > 0)
            setCarouselPosition(carouselPosition - 1);
    };
    return (<div className={styles.carousel}>
      <button className={`${styles.button} ${styles.prev}`} onClick={handlePrev}>
        Previous
        <img src={getIconBaseUrl('arrow-ios-right-blue.svg')} alt={`get previous ${topic}`}/>
      </button>
      <div className={styles.inner}>
        <ul className={styles.list} style={{
            width: `${dates.length * 48}px`,
            left: `${carouselPosition * (-48 * 4)}px`,
        }}>
          {dates === null || dates === void 0 ? void 0 : dates.map((date) => (<li key={date.title} className={styles.item}>
              <SelectBox name={name} onChange={() => {
                onChange(date);
            }} title={date.title} value={date.value} checked={date.value === preSelectedNights} singleNumber/>
            </li>))}
        </ul>
      </div>
      <button className={styles.button} onClick={handleNext}>
        Next
        <img src={getIconBaseUrl('arrow-ios-right-blue.svg')} alt={`get next ${topic}`}/>
      </button>
    </div>);
};
